import { render } from "./FieldInfo.vue?vue&type=template&id=c647a106&ts=true"
import script from "./FieldInfo.vue?vue&type=script&lang=ts"
export * from "./FieldInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__